<script>
import { mapState } from 'vuex';
import Button from '@/components/Button';
import MainCard from '@/components/MainCard';

export default {
  name: 'StakeSelect',
  components: {
    Button,
    MainCard,
  },
  computed: {
    ...mapState({
      chainId: (state) => state.User.chainId,
    }),
    isAllowedChain() {
      return [1, 4, 56, 97, 43113, 43114].includes(this.chainId);
    },
  },
};
</script>

<template>
  <div>
    <div class="main-wrap launchpad main-wrap--narrow">
      <div v-if="!isAllowedChain">
        <v-row justify="center">
          <h1>{{ $t('upcoming.ethereum-only') }}</h1>
        </v-row>
      </div>
      <v-container class="mt-10" v-else>
        <v-row justify="space-around" class="mt-10">
          <v-col cols="12" md="6">
            <MainCard class="index-page-card--milk-pool">
              <template #card-title>
                {{ $t('staking.milk2-title') }}
              </template>
              <template #card-info></template>
              <template #card-button>
                <Button
                  to="/staking/milk2">
                  {{ $t('staking.btn-stake') }}
                </Button>
              </template>
            </MainCard>
          </v-col>
          <v-col cols="12" md="6">
            <MainCard class="index-page-card--shake-pool">
              <template #card-title>
                {{ $t('staking.shake-title') }}
              </template>
              <template #card-info></template>
              <template #card-button>
                <Button to="/staking/shake">
                  {{ $t('staking.btn-stake') }}
                </Button>
              </template>
            </MainCard>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="main-wrap">
      <div class="text-right launchpad__link">
        <router-link :to="{ name: 'agreement' }">User Agreement</router-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

</style>
